import React from "react";
import Carousel from "react-bootstrap/Carousel";
import KitchenPic from "../assets/kitchen.jpg";
import furniture from "../assets/furniture1.jpg";
import "./CSS/Carousel.css";
import "@/bootstrap-custom.scss";

function CarouselComponent({ images }) {
  // Default images if none provided
  const defaultImages = [
    { imageUrl: KitchenPic, altText: "Kitchen setup" },
    { imageUrl: furniture, altText: "Modern furniture" },
    { imageUrl: KitchenPic, altText: "Elegant design" },
  ];

  const slides = images && images.length > 0 ? images : defaultImages;

  return (
    <Carousel data-bs-theme="dark" className="carousel-custom">
      {slides.map((img, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100 carousel-image"
            src={img.imageUrl}
            alt={img.altText || `Slide ${index + 1}`}
          />
          {/* Optional: If you want captions later */}
          {/* <Carousel.Caption>
            <h5>{img.captionTitle}</h5>
            <p>{img.captionText}</p>
          </Carousel.Caption> */}
        </Carousel.Item>
      ))}
    </Carousel>
  );
}

export default CarouselComponent;
